module.exports = __webpack_public_path__ + "static/img/duom066.d423179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom066.png
// module id = 993
// module chunks = 0